export class RestoreGoogleWorkspaceUserRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "googleWorkspaceWholeUser",
            "baseName": "googleWorkspaceWholeUser",
            "type": "GoogleWorkspaceWholeUserRestore",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceUserRequest.attributeTypeMap;
    }
    constructor() {
    }
}
